import Vue from "vue";
import App from "./App.vue";

//Utils
import { CustomCSSProperties } from "./utils/cutsomStyles";
import { AddOnTypes, TemplateTypes } from "./utils/addOnTypes";

type TemplateBuilderProps = {
  container: string | null;
  secretKey: string;
  publicApiKey: string;
  platformName?: string | null;
  templateGalleryModal?: boolean;
  createTemplateRoute?: string | null;
  templateBuilderRoute?: string | null;
  olcTemplate?: Record<string, any>;
  designerTemplateQuery?: Record<string, any> | null;
  sandbox?: boolean;
  allowSenderFields?: boolean;
  allowPropertyFields?: boolean;
  excludedFields?: string[] | null;
  designerQueryAmount?: string | number;
  allowedAddOns?: AddOnTypes[] | string[] | null | undefined;
  allowedTemplateSections?: TemplateTypes[] | string[] | null | undefined;
  env?: string;
  restrictedProducts?: number[] | null | undefined;
  onReturnAndNavigate?: () => void;
  onCreateCustomTemplateQuery?: (payload: any) => Promise<any>;
  onGetOneTemplate?: (payload: any) => Promise<any>;
  onGetTemplates?: (payload: any) => Promise<any>;
  onGetCustomFields?: () => Promise<any>;
  onDuplicateTemplate?: (payload: any) => Promise<any>;
  onSubmit?: (payload: any) => Promise<any>;
  styles?: {
    root?: CustomCSSProperties;
  };
}

const TemplateBuilder = ({
  container,
  secretKey,
  publicApiKey,
  platformName,
  templateGalleryModal = true,
  createTemplateRoute,
  templateBuilderRoute,
  olcTemplate,
  designerTemplateQuery,
  sandbox,
  allowSenderFields,
  allowPropertyFields,
  excludedFields,
  designerQueryAmount,
  allowedAddOns,
  allowedTemplateSections,
  env,
  restrictedProducts,
  onReturnAndNavigate,
  onCreateCustomTemplateQuery,
  onGetOneTemplate,
  onGetTemplates,
  onGetCustomFields,
  onDuplicateTemplate,
  onSubmit,
  styles,
}: TemplateBuilderProps) => {
  const props = {
    container,
    secretKey,
    publicApiKey,
    platformName,
    templateGalleryModal,
    createTemplateRoute,
    templateBuilderRoute,
    olcTemplate,
    designerTemplateQuery,
    sandbox,
    allowSenderFields,
    allowPropertyFields,
    excludedFields,
    designerQueryAmount,
    allowedAddOns,
    allowedTemplateSections,
    env,
    restrictedProducts,
    onReturnAndNavigate,
    onCreateCustomTemplateQuery,
    onGetOneTemplate,
    onGetTemplates,
    onGetCustomFields,
    onDuplicateTemplate,
    onSubmit,
    styles,
  };

  const vueInstance = new Vue({
    render: (h) => h(App, { props }),
  }).$mount(`#${container}`);

  return {
    destroy() {
      vueInstance.$destroy();
    },
  };
};

export default TemplateBuilder;